import { Action, Entity } from '../../types/permissions'

export enum TableHeaderType {
  Card = 'card',
  Default = 'default',
}

export type TableActionConfig<T> = {
  name: string | ((row: T) => string)
  icon: React.ReactNode | ((row: T) => React.ReactNode)
  handler: (row: T) => void
  permission?: { entity: Entity; action: Action }
  isCustom?: boolean
  format?: (row: T) => React.ReactNode
}
